// THIS FILE IS AUTO-GENERATED BY vite-plugin-api-constructor.
// DO NOT EDIT MANUALLY.

export const APIEndPoints = {
  "/users/info": ["GET"],
  "/tracks": ["GET"],
  "/courses": ["GET"],
  "/reviews": ["GET", "POST"],
  "/lectures": ["GET"],
  "/schedules": ["GET"],
  "/semesters": ["GET"],
  "/timetables": ["GET", "POST", "PATCH", "DELETE"],
  "/courses/:courseId": ["GET"],
  "/semesters/current": ["GET"],
  "/sync/requests": ["POST"],
  "/sync/requests/active": ["GET"],
  "/courses/auto-complete": ["GET"],
  "/planner-courses": ["GET"],
  "/users/writable-review": ["GET"],
  "/users/written-reviews": ["GET"],
  "/users/:userId/lectures": ["GET"],
  "/users/:userId/wishlist": ["GET", "PATCH"],
  "/reviews/:reviewId": ["PUT"],
  "/reviews/:reviewId/liked": ["PATCH"],
  "/timetables/:timetableId": ["GET", "PATCH"],
  "/timetables/my-timetable": ["GET"],
  "/department-options": ["GET"],
  "/users/:userId/reviews/liked": ["GET"],
  "/users/:userId/planners": ["GET", "POST"],
  "/sync/requests/:requestId/stream": ["GET"],
  "/users/:userId/interested-departments": ["PUT"],
  "/users/:userId/planners/:plannerId": ["PATCH", "DELETE"],
  "/users/:userId/planners/:plannerId/reorder": ["POST"],
  "/timetables/:timetableId/custom-blocks": ["GET", "POST"],
  "/users/:userId/planners/:plannerId/remove-item": ["POST"],
  "/users/:userId/planners/:plannerId/update-item": ["POST"],
  "/users/:userId/planners/:plannerId/add-future-item": ["POST"],
  "/timetables/:timetableId/custom-blocks/:customblockId": ["PATCH", "DELETE"],
  "/users/:userId/planners/:plannerId/add-arbitrary-item": ["POST"],
} as const;

export type APIEndPoint = keyof typeof APIEndPoints;
export type APIMethodOf<P extends APIEndPoint> = (typeof APIEndPoints)[P][number];
